import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import Shearchbar from "./Shearchbar";
import Navbar from "./Navbar";
import Manubar from "./Manubar";
import "./Address.css";

const Address = () => {
  const navigate = useNavigate();
  const [addresses, setAddresses] = useState([]);
  const [showAddForm, setShowAddForm] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [addressType, setAddressType] = useState("Home");
  const [formData, setFormData] = useState({
    address_id: "",
    user_id: "",
    landmark: "",
    address: "",
    city: "",
    pin_code: "",
  });
  const _id = secureLocalStorage.getItem("n_id");
  const token = secureLocalStorage.getItem("n_token");
  const location = useLocation();
  const fromCart = location.state?.fromCart;

  // Fetch all addresses
  useEffect(() => {
    fetchAddresses();
  }, []);

  const fetchAddresses = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}website/get_address`,
        { user_id: _id },
      );

      if (response.data.result) {
        setAddresses(response.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching addresses:", error);
    }
  };

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle add/update address
  const handleSubmit = async () => {
    try {
      const endpoint = isEditing
        ? `${process.env.REACT_APP_API}website/update_address`
        : `${process.env.REACT_APP_API}website/add_address`;

      const payload = {
        ...formData,
        user_id: _id,
        address_type: addressType,
      };

      const response = await axios.post(endpoint, payload, {
        headers: {
          token: token,
        },
      });

      if (response.data.result) {
        alert(
          isEditing
            ? "Address updated successfully!"
            : "Address added successfully!",
        );
        fetchAddresses();
        resetForm();
      } else {
        alert(response.data.message || "Operation failed");
      }
    } catch (error) {
      console.error("Error saving address:", error);
      alert("Failed to save address");
    }
  };

  // Handle edit
  const handleEdit = (address) => {
    setFormData({
      address_id: address._id || address.address_id,
      landmark: address.landmark || "",
      address: address.address || "",
      city: address.city || "",
      pin_code: address.pin_code || "",
    });
    setAddressType(address.address_type || "Home");
    setIsEditing(true);
    setShowAddForm(true);
  };

  // Handle delete
  const handleDelete = async (addressId) => {
    if (window.confirm("Are you sure you want to delete this address?")) {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API}website/delete_address`,
          {
            user_id: _id,
            address_id: addressId,
          },
          {
            headers: {
              token: token,
            },
          },
        );

        if (response.data.result) {
          alert("Address deleted successfully!");
          fetchAddresses();
        } else {
          alert(response.data.message || "Delete failed");
        }
      } catch (error) {
        console.error("Error deleting address:", error);
        alert("Failed to delete address");
      }
    }
  };

  // Reset form
  const resetForm = () => {
    setFormData({
      address_id: "",
      landmark: "",
      address: "",
      city: "",
      pin_code: "",
    });
    setAddressType("Home");
    setIsEditing(false);
    setShowAddForm(false);
  };

  return (
    <div className="address-container">
      <div className="modal fade offcanvas-modal" id="exampleModal">
        <div className="modal-dialog offcanvas-dialog">
          <div className="modal-content">
            <Manubar />
          </div>
        </div>
      </div>

      <header>
        <Shearchbar />

        <Navbar />
      </header>
      {/* Header */}
      <div className="address-header">
        <button className="back-button" onClick={() => navigate(-1)}>
          <i className="las la-arrow-left"></i>
        </button>
        <h2>
          {showAddForm
            ? isEditing
              ? "Edit Address"
              : "Add Address"
            : "Address"}
        </h2>
      </div>

      {/* Add Address Form */}
      {showAddForm ? (
        <div className="add-address-form">
          <div className="form-group">
            <label>Your location (Apartment / Road / Line)</label>
            <input
              type="text"
              name="landmark"
              value={formData.landmark}
              onChange={handleInputChange}
              placeholder="Nana Varachha, Surat, Gujarat 395006, India"
            />
          </div>

          <div className="form-group">
            <label>Street</label>
            <input
              type="text"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
              placeholder="EX. Street Road"
            />
          </div>

          <div className="form-group">
            <label>City</label>
            <input
              type="text"
              name="city"
              value={formData.city}
              onChange={handleInputChange}
              placeholder="EX. Indore"
            />
          </div>

          <div className="form-group">
            <label>pincode</label>
            <input
              type="text"
              name="pin_code"
              value={formData.pin_code}
              onChange={handleInputChange}
              placeholder="EX. 590006"
            />
          </div>

          <div className="address-type-selector">
            <button
              className={`type-btn ${addressType === "Home" ? "active" : ""}`}
              onClick={() => setAddressType("Home")}
            >
              <i className="las la-home"></i>
              Home
            </button>
            <button
              className={`type-btn ${addressType === "Other" ? "active" : ""}`}
              onClick={() => setAddressType("Other")}
            >
              <i className="las la-map-marker"></i>
              Other
            </button>
          </div>

          <div className="form-actions">
            <button className="save-btn" onClick={handleSubmit}>
              Save
            </button>
            <button className="cancel-btn" onClick={resetForm}>
              Cancel
            </button>
          </div>
        </div>
      ) : (
        <>
          {/* Add New Address Button */}
          <div className="add-new-address-wrapper">
            <button
              className="add-new-address-btn"
              onClick={() => setShowAddForm(true)}
            >
              <i className="las la-plus"></i>
              Add New Address
            </button>
          </div>

          {/* Address List */}
          <div className="address-list">
            {addresses.length > 0 ? (
              addresses.map((address, index) => (
                <div key={index} className="address-card">
                  <div className="address-info" onClick={() => fromCart && navigate("/cardlist", { state: { selectAddress: address } })}>
                    <h3 className="address-title">
                      {address.city || "No Title"}
                    </h3>
                    <p className="address-detail">
                      {address.city} Pincode: {address.pin_code}
                    </p>
                    <p className="address-detail">{address.address}</p>
                    {address.landmark && (
                      <p className="address-landmark">{address.landmark}</p>
                    )}
                  </div>
                  <div className="address-actions">
                    <button
                      className="edit-btn"
                      onClick={() => handleEdit(address)}
                    >
                      Edit
                    </button>
                    <button
                      className="delete-btn"
                      onClick={() =>
                        handleDelete(address._id || address.address_id)
                      }
                    >
                      Delete
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div className="no-address">
                <p>No addresses found. Add your first address!</p>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default Address;
